import { render, staticRenderFns } from "./BSclassSearch.form.vue?vue&type=template&id=6368a27f&"
import script from "./BSclassSearch.form.vue?vue&type=script&lang=js&"
export * from "./BSclassSearch.form.vue?vue&type=script&lang=js&"
import style0 from "./BSclassSearch.form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports